import { Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import BlueLink from '../ui/BlueLink';
import { authConsentSx } from './authDialogStyles';

export const LEGAL_LINKS = {
    agreement: 'https://blog.fleep.bot/user_agreement',
    privacy: 'https://blog.fleep.bot/privacy_policy',
    offer: 'https://blog.fleep.bot/offer',
};

const consentLinkSx = {
    fontSize: 14,
    lineHeight: '130%',
};

const linkProps = {
    icon: false,
    withUnderline: false,
    target: '_blank',
    rel: 'noopener noreferrer',
    sx: consentLinkSx,
};

const AuthConsentLabel = () => {
    const { i18n } = useTranslation();
    const isRu = !i18n.language || i18n.language.startsWith('ru');

    if (isRu) {
        return (
            <Typography component='span' sx={authConsentSx}>
                Нажимая кнопку ниже, вы соглашаетесь с{' '}
                <BlueLink href={LEGAL_LINKS.agreement} {...linkProps}>
                    Пользовательским соглашением
                </BlueLink>
                {', '}
                <BlueLink href={LEGAL_LINKS.privacy} {...linkProps}>
                    Политикой конфиденциальности
                </BlueLink>
                {' '}
                и
                {' '}
                <BlueLink href={LEGAL_LINKS.offer} {...linkProps}>
                    Офертой
                </BlueLink>
                .
            </Typography>
        );
    }

    return (
        <Typography component='span' sx={authConsentSx}>
            By clicking the button below, you agree to the{' '}
            <BlueLink href={LEGAL_LINKS.agreement} {...linkProps}>
                User Agreement
            </BlueLink>
            {', '}
            <BlueLink href={LEGAL_LINKS.privacy} {...linkProps}>
                Privacy Policy
            </BlueLink>
            {' '}
            and
            {' '}
            <BlueLink href={LEGAL_LINKS.offer} {...linkProps}>
                Offer
            </BlueLink>
            .
        </Typography>
    );
};

export default AuthConsentLabel;
